import type { ReactNode } from "react";
import { useQuoteDocumentContext } from "./quoteDocumentContext";

interface EmptyChromePlaceholderProps {
  /** Which chrome block the hint names. */
  kind: "header" | "footer";
}

/**
 * Ghost hint drawn inside an empty repeatable header or footer on the editor
 * canvas. An empty chrome block renders zero-height, leaving nothing to click -
 * yet it still counts as the document's one header or footer, so the author
 * could neither see it, delete it, nor insert a fresh one. It is chrome, not
 * content: outside the editor it renders nothing, so the customer page and the
 * PDF show the empty block exactly as authored.
 * @param kind - Which chrome block the hint names
 * @returns The hint in the editor, or null everywhere else
 */
export function EmptyChromePlaceholder({
  kind,
}: EmptyChromePlaceholderProps): ReactNode {
  const { editable } = useQuoteDocumentContext();
  if (!editable) {
    return null;
  }
  return (
    <div
      aria-hidden
      className="select-none rounded border border-dashed border-gray-300 px-3 py-2 text-xs text-gray-400"
    >
      Empty {kind} - use the + buttons to add blocks into it, or press Delete to
      remove it.
    </div>
  );
}
